import React, { useState, useEffect } from "react";
import axios from 'axios';
import "./styleLogin.css";
import { useNavigate } from "react-router-dom";
import logo from '../../logos/MSALogoFinal.png';

const Login = () => {
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [isLoginError, setIsLoginError] = useState(false);
    const [showChoiceModal, setShowChoiceModal] = useState(false);
    const [showClientSelection, setShowClientSelection] = useState(false);
    const [availableClients, setAvailableClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const checkLoginStatus = async () => {
            try {
                const { data } = await axios.get('/api/isLoggedIn');
                if (data.loggedIn) {
                    navigate('/');
                }
            } catch (error) {
                console.error("Error checking login status:", error);
            }
        };
        
        checkLoginStatus();
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoginError(false);
        setIsLoading(true);
        
        try {
            // First, get all clients for this email/password
            const response = await axios.post('/userLogin/get-clients', formData);
            const { clients, user, tokens } = response.data;
            
            if (clients.length === 0) {
                setIsLoginError(true);
                setIsLoading(false);
                return;
            } else if (clients.length === 1) {
                // Only one client, proceed directly
                await proceedWithLogin(clients[0], user, tokens);
            } else {
                // Multiple clients, show selection
                setAvailableClients(clients);
                setShowClientSelection(true);
                setIsLoading(false);
            }
        } catch (error) {
            console.log('Login error:', error.response?.data || error);
            setIsLoginError(true);
            setIsLoading(false);
        }
    };

    const handleClientSelection = async (e) => {
        e.preventDefault();
        if (!selectedClient) {
            alert('Please select a client');
            return;
        }
        
        setIsLoading(true);
        const selectedClientData = availableClients.find(client => client.clientID.toString() === selectedClient);
        
        if (selectedClientData) {
            // Re-authenticate with the selected client
            try {
                const response = await axios.post('/userLogin', {
                    ...formData,
                    selectedClientID: selectedClientData.clientID
                });
                
                const { plan, userInfo, clientInfo } = response.data;
                
                // Identify user in PostHog Analytics
                if (window.posthog && typeof window.posthog.identify === 'function') {
                    window.posthog.identify(userInfo.EmailAddress, {
                        firstName: userInfo.FirstName,
                        lastName: userInfo.LastName,
                        clientName: clientInfo?.ClientName || userInfo.ClientName,
                        email: userInfo.EmailAddress
                    });
                }
                
                const tempFilters = ['Hydrant', 'Manhole', 'Valve', 'TrafficSign', 'WaterMeter', 'WaterLine', 'SewerLine'];
                localStorage.setItem('markerFilters', tempFilters.toString());
                window.dispatchEvent(new Event("storage"));
                
                // Route based on plan
                if (plan === 1) {
                    // Map system only
                    window.location = '/map';
                } else if (plan === 2) {
                    // Call module only
                    window.location = '/calls';
                } else if (plan === 3) {
                    // Both modules - show choice modal
                    setShowChoiceModal(true);
                } else {
                    // No plan or invalid plan - show choice modal as fallback
                    console.warn('No valid plan found, showing choice modal');
                    setShowChoiceModal(true);
                }
            } catch (error) {
                console.log('Client selection error:', error.response?.data || error);
                setIsLoginError(true);
                setIsLoading(false);
            }
        }
    };

    const proceedWithLogin = async (clientData, user, tokens) => {
        try {
            const response = await axios.post('/userLogin', {
                ...formData,
                selectedClientID: clientData.clientID
            });
            
            const { plan, userInfo, clientInfo } = response.data;
            
            // Identify user in PostHog Analytics
            if (window.posthog && typeof window.posthog.identify === 'function') {
                window.posthog.identify(userInfo.EmailAddress, {
                    firstName: userInfo.FirstName,
                    lastName: userInfo.LastName,
                    clientName: clientInfo?.ClientName || userInfo.ClientName,
                    email: userInfo.EmailAddress
                });
            }
            
            const tempFilters = ['Hydrant', 'Manhole', 'Valve', 'TrafficSign', 'WaterMeter', 'WaterLine', 'SewerLine'];
            localStorage.setItem('markerFilters', tempFilters.toString());
            window.dispatchEvent(new Event("storage"));
            
            // Route based on plan
            if (plan === 1) {
                // Map system only
                window.location = '/map';
            } else if (plan === 2) {
                // Call module only
                window.location = '/calls';
            } else if (plan === 3) {
                // Both modules - show choice modal
                setShowChoiceModal(true);
            } else {
                // No plan or invalid plan - show choice modal as fallback
                console.warn('No valid plan found, showing choice modal');
                setShowChoiceModal(true);
            }
        } catch (error) {
            console.log('Proceed login error:', error.response?.data || error);
            setIsLoginError(true);
            setIsLoading(false);
        }
    };

    const handleChoice = (path) => {
        setShowChoiceModal(false);
        window.location = path;
    };

    const resetPassword = (e) => {
        e.preventDefault();
        const { email } = formData;
        
        if (!email) {
            alert('Please enter an email to reset password');
            return;
        }
        
        if (!email.includes('@') || !email.includes('.')) {
            alert('Please enter a valid email in the email field to reset password');
            return;
        }
        
        axios.post('/resetPassword', { Email: email })
            .then(() => {
                alert('If the email you entered is associated with an account, you will receive an email with instructions to reset your password');
            })
            .catch(() => {
                alert('Error sending password reset email / Email not associated with an account');
            });
    };

    return (
        <div className="loginBackGround">
            <div className="loginContainer">
                <form className="login">
                    <img src={logo} alt="logo" style={{ padding: '20px', width: '80%', height: 'auto', margin: 'auto', display: 'block' }} />
                    
                    <p style={{color: '#1f3fc3', textAlign: 'center', fontSize: '13px', fontWeight: 700}}>
                    Our Mapping tool is $84 per month, or $1000 per year.  Use Call Tracking for $84 per month, or $1000 per year.  Use both for $150 per month or $1800 per year.  No contract or long-term commitment.  Unlimited Users.
                    </p>
                    
                    <div className="login__field" style={{ paddingBottom: '0px' }}>
                        <i className="login__icon fas fa-user"></i>
                        <input type="text" className="login__input" name='email' placeholder="User name / Email" 
                            style={{ boxShadow: '0px 2px 11px #000000b0' }} onChange={handleInputChange} />
                    </div>
                    <div className="login__field" style={{ paddingBottom: '46px' }}>
                        <i className="login__icon fas fa-lock"></i>
                        <input type="password" className="login__input" name='password' placeholder="Password" 
                            style={{ boxShadow: '0px 2px 11px #000000b0' }} onChange={handleInputChange} />
                    </div>
                    
                    {isLoginError && <p style={{color: 'red', textAlign: 'center'}}>Error Logging in. Try Again.</p>}
                    
                    <div>
                        <button 
                            className="button login__submit" 
                            style={{ boxShadow: '0px 2px 11px #000000b0' }} 
                            onClick={handleSubmit}
                            disabled={isLoading}
                        >
                            <span className="button__text">
                                {isLoading ? 'Logging in...' : 'Log In Now'}
                            </span>
                            <i className="button__icon fas fa-chevron-right"></i>
                        </button>
                        <div style={{ marginTop: '17px' }}>
                            <button className="button login__submit" style={{ boxShadow: '0px 2px 11px #000000b0' }} onClick={resetPassword}>
                                <span className="button__text">Reset Password</span>
                                <i className="button__icon fas fa-chevron-right"></i>
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            {/* Client Selection Modal */}
            {showClientSelection && (
                <div className="choice-modal-overlay">
                    <div className="choice-modal">
                        <div className="choice-modal-content">
                            <h2 style={{ 
                                color: '#452d9f', 
                                textAlign: 'center', 
                                marginBottom: '20px',
                                fontSize: '24px',
                                fontWeight: '700'
                            }}>
                                Select Client Organization
                            </h2>
                            
                            <p style={{ 
                                textAlign: 'center', 
                                marginBottom: '30px', 
                                color: '#666',
                                fontSize: '16px'
                            }}>
                                You have access to multiple client organizations. Please select which one you'd like to log into:
                            </p>
                            
                            <form onSubmit={handleClientSelection}>
                                <div style={{ marginBottom: '30px' }}>
                                    <select
                                        value={selectedClient}
                                        onChange={(e) => setSelectedClient(e.target.value)}
                                        style={{
                                            width: '100%',
                                            padding: '15px',
                                            fontSize: '16px',
                                            border: '2px solid #ddd',
                                            borderRadius: '8px',
                                            backgroundColor: 'white',
                                            boxShadow: '0px 2px 11px #000000b0'
                                        }}
                                        required
                                    >
                                        <option value="">Select a client organization...</option>
                                        {availableClients.map((client) => (
                                            <option key={client.clientID} value={client.clientID}>
                                                {client.clientName} {client.plan ? `(Plan ${client.plan})` : ''}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                
                                <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
                                    <button 
                                        type="submit"
                                        className="button login__submit"
                                        style={{ 
                                            boxShadow: '0px 2px 11px #000000b0',
                                            backgroundColor: '#452d9f',
                                            color: 'white',
                                            padding: '12px 30px',
                                            fontSize: '16px',
                                            fontWeight: '600'
                                        }}
                                        disabled={isLoading}
                                    >
                                        {isLoading ? 'Logging in...' : 'Continue'}
                                    </button>
                                    
                                    <button 
                                        type="button"
                                        className="button login__submit"
                                        style={{ 
                                            boxShadow: '0px 2px 11px #000000b0',
                                            backgroundColor: '#6c757d',
                                            color: 'white',
                                            padding: '12px 30px',
                                            fontSize: '16px',
                                            fontWeight: '600'
                                        }}
                                        onClick={() => {
                                            setShowClientSelection(false);
                                            setSelectedClient('');
                                            setAvailableClients([]);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Choice Modal */}
            {showChoiceModal && (
                <div className="choice-modal-overlay">
                    <div className="choice-modal">
                        <div className="choice-modal-content">
                            <h2 style={{ 
                                color: '#452d9f', 
                                textAlign: 'center', 
                                marginBottom: '20px',
                                fontSize: '24px',
                                fontWeight: '700'
                            }}>
                                Welcome! You have access to both modules. Where would you like to go?
                            </h2>
                            
                            <div className="choice-buttons">
                                <button 
                                    className="choice-button map-button"
                                    onClick={() => handleChoice('/map')}
                                >
                                    <i className="fas fa-map-marked-alt" style={{ fontSize: '32px', marginBottom: '10px' }}></i>
                                    <span className="choice-title">Map View</span>
                                    <span className="choice-description">View and manage city assets on the map</span>
                                </button>
                                
                                <button 
                                    className="choice-button calls-button"
                                    onClick={() => handleChoice('/calls')}
                                >
                                    <i className="fas fa-phone-alt" style={{ fontSize: '32px', marginBottom: '10px' }}></i>
                                    <span className="choice-title">Call System</span>
                                    <span className="choice-description">Manage phone calls and communications</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Login;
